<template>
    <a
        class="block h-full w-full text-left"
        :href="review.url"
        target="_blank"
        rel="noopener noreferrer"
    >
        <p class="font-serif text-lg font-light italic leading-relaxed text-foam/80 sm:text-xl">
            &ldquo;<span v-html="review.quote" />&rdquo;
        </p>

        <div class="eyebrow whitespace-nowrap">
            &mdash; <span v-text="review.name" />
        </div>
    </a>
</template>

<script>
    // Models
    import Review from '@/models/Review.model';
    // Library
    import { defineComponent } from 'vue';

    export default defineComponent({
        name: 'ReviewComponent',

        props: {
            review: {
                type: Review,
                required: true,
            },
        },
    });
</script>
